export const categories = [
  {
    slug: "classic",
    name: "经典",
    en: "Classic",
    icon: "ri-video-line",
    summary: "昭和末年至平成初年的代表作品，以室内调度与留白见长。",
    description:
      "经典单元收录上世纪八十年代至九十年代之间的日本成人文艺电影代表作。这一时期的作品多以低照度摄影、狭小室内空间与长镜头构图完成叙事，情绪依赖光影与沉默，而非直白表达。本站以资料整理的角度，记录这些影片的导演脉络、摄影风格与时代语境。",
    count: 6,
  },
  {
    slug: "new",
    name: "新片",
    en: "New Release",
    icon: "ri-film-line",
    summary: "近期上线的作品，数字摄影与复古胶片质感并行。",
    description:
      "新片单元聚焦近三年内上映或修复重映的日本成人文艺电影。数字摄影让夜戏与低照度场景更具层次，同时不少导演重新使用十六毫米胶片，追求颗粒感与失焦的暧昧气质。这里可以看到新一代创作者如何在类型框架内处理亲密关系与城市孤独。",
    count: 7,
  },
  {
    slug: "drama",
    name: "剧情",
    en: "Drama",
    icon: "ri-book-open-line",
    summary: "以人物关系为核心，情节推进克制的叙事作品。",
    description:
      "剧情单元的影片通常围绕两至三个人物展开，场景集中在公寓、旅馆与深夜街道。剧本强调对话的间隙与未说出口的部分，剪辑节奏偏慢，适合愿意耐心进入人物内心的观众。",
    count: 12,
  },
  {
    slug: "romance",
    name: "浪漫",
    en: "Romance",
    icon: "ri-heart-3-line",
    summary: "以季节与地域为背景的抒情向作品。",
    description:
      "浪漫单元偏爱季节感：梅雨、盛夏、落雪与樱花。故事结构往往简单，却依靠光线、音乐与地景把情绪推到极处。适合在深夜独自观看，也适合作为日本各地城市气质的影像索引。",
    count: 11,
  },
  {
    slug: "noir",
    name: "暗黑",
    en: "Noir",
    icon: "ri-moon-foggy-line",
    summary: "霓虹、雨夜与道德灰度，带有黑色电影基因。",
    description:
      "暗黑单元的作品继承黑色电影的视觉传统：低角度构图、湿漉漉的柏油路、窗外闪烁的霓虹招牌。人物动机常常模糊，结局不作道德裁决，让观众自行判断。",
    count: 7,
  },
  {
    slug: "retro",
    name: "复古",
    en: "Retro",
    icon: "ri-camera-lens-line",
    summary: "以胶片质感与老街区场景重现旧时代氛围。",
    description:
      "复古单元以年代还原为乐趣：木质旅馆、和式纸门、老式唱机与土黄色滤镜。影片在造型与美术上投入极多，即使抛开情节，也值得作为一次昭和美学的视觉旅行。",
    count: 3,
  },
];